require('./bizumConfirmation.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @ utilities
const { formatText } = require('core/i18n').i18n;
const { toFirstUppercase } = require('utilities/stringHelper');
// @ components
const CustomMessageBox = require('components/contactCenter/customMessageBox/customMessageBox');
const BizumConfirmationStep = require('components/contactCenter/bizumConfirmation/bizumConfirmationStep/bizumConfirmationStep.js');
const BizumConfirmationCodeValidationStep = require('components/contactCenter/bizumConfirmation/bizumConfirmationCodeValidationStep/bizumConfirmationCodeValidationStep.js');
const PreleaveCancelModal = require('components/contactCenter/preleaveCancelModal/preleaveCancelModal');
// @ commons
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
const { OKButton } = require('components/commons/OKButton/OKButton');
// @ actions
const bizumConfirmation = require('actions/bizumConfirmation.js');

class BizumConfirmation extends React.Component {

    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.handleResendClick = this.handleResendSms.bind(this);
        this.handleFinishClick = this.handleFinishClick.bind(this);
        this.handleToggleCancelModal = this.handleToggleCancelModal.bind(this);
        this.handleTextChange = this.handleTextChange.bind(this);
        this.handleCancelClick = this.handleCancelClick.bind(this);
        this.handleOnCancelModal = this.handleOnCancelModal.bind(this);
        this.goBackHandler = this.goBackHandler.bind(this);
    }

    componentWillUpdate(nextProps) {
        const {
            confirmationSuccess,
            confirmationFailure,
            confirmationError,
            resendSuccess,
            resendFailure
        } = nextProps.bizumConfirmation.toJS();

        if (confirmationSuccess) {
            this.props.setScreen(3);

        } else if (confirmationFailure) {
            this.props.setScreen(2); // in this case entered code is invalid

        } else if (confirmationError) {
            this.props.setScreen(4); // In case API call fails

        } else if (resendSuccess) {
            this.props.setScreen(1);

        } else if (resendFailure) {
            this.props.setScreen(4); // if Resend fails then error screen is displayed
        }
    }

    componentWillUnmount() {
        this.props.reset();
    }

    handleOnCancelModal() {
        const url = '/myprofile/transfers';
        this.props.showModal(false);
        this.props.history.push(url);
    }

    handleToggleCancelModal() {
        this.props.showModal(false);
    }

    handleTextChange(text, isInvalidText) {
        this.props.setCode({text, isInvalidText});
    }

    handleResendSms() {
        this.props.resend();
    }

    handleFinishClick() {
        const screen = this.props.bizumConfirmation.get("screen");
        switch (screen) {
            case 0:
                return this.props.setScreen(1);
            case 1:
            case 2:
                return this.props.validate();
        }
    }

    handleCancelClick() {
        this.props.showModal(true);
    }

    getCancelButton() {
        return (
            <div className="bizum-confirmation-wizard-step__first-button">
                <OKButton
                    modifier="additional-action-secondary"
                    onClick={this.handleCancelClick}
                >
                    {toFirstUppercase(formatText('buttonsActions-cancel'))}
                </OKButton>
            </div>
        )
    }

    getFinishButton() {
        const {isWaiting, isInvalidSmsCode, screen} = this.props.bizumConfirmation.toJS();
        return (
            <div className="bizum-confirmation-wizard-step__fourth-button">
                <OKButton
                    loading={isWaiting}
                    disabled={isInvalidSmsCode && screen > 0}
                    onClick={this.handleFinishClick}
                >
                    {toFirstUppercase(formatText('buttonsActions-confirm'))}
                </OKButton>
            </div>
        );
    }

    goBackHandler() {
        this.props.history.push('/myprofile/transfers');
    }

    buildPreleaveCancelModal() {
        const showModal = this.props.bizumConfirmation.get("showModal");
        return (
            <PreleaveCancelModal
                isOpen={showModal}
                onCancel={this.handleOnCancelModal}
                onCloseModal={this.handleToggleCancelModal}
                onStayHere={this.handleToggleCancelModal}
            />
        );
    }

    getMainContent() {
        const {screen, isWaiting, smsCode} = this.props.bizumConfirmation.toJS();
        const successMessageTitle = formatText('portability-registerSuccessTitle');
        const successMessageText = formatText('portability-registerSuccessText');
        const errorMessageTitle = formatText('portability-registerErrorTitle');
        const errorMessageText = formatText('portability-registerErrorText');
        const goBackButtonLabel = formatText('portability-back');
        switch (screen) {
            case 0: // initial warning
                return (
                    <div className="bizum-confirmation-wizard-step__data-wrapper">
                        <BizumConfirmationStep>
                            <div>
                                {this.getCancelButton()}
                                {this.getFinishButton()}
                            </div>
                        </BizumConfirmationStep>
                    </div>
                );
            case 1: // get SMS code
                return (
                    <div className="bizum-confirmation-wizard-step__data-wrapper">
                        <BizumConfirmationCodeValidationStep
                            isDisabled={isWaiting}
                            inputValue={smsCode}
                            isCodeValid={true}
                            onTextChange={this.handleTextChange}
                            onResendClick={this.handleResendClick}
                            >
                            <div>
                                {this.getCancelButton()}
                                {this.getFinishButton()}
                            </div>
                        </BizumConfirmationCodeValidationStep>
                    </div>
                );
            case 2: // wrong SMS code
                return (
                    <div className="bizum-confirmation-wizard-step__data-wrapper">
                        <BizumConfirmationCodeValidationStep
                            isDisabled={isWaiting}
                            inputValue={smsCode}
                            isCodeValid={false}
                            onTextChange={this.handleTextChange}
                            onResendClick={this.handleResendClick}
                            >
                            <div>
                                {this.getCancelButton()}
                                {this.getFinishButton()}
                            </div>
                        </BizumConfirmationCodeValidationStep>
                    </div>
                );
            case 3: // success
                return (
                    <div>
                        <CustomMessageBox
                            icon="icon-success"
                            title={successMessageTitle}
                            textLink={goBackButtonLabel}
                            goBackHandler={this.goBackHandler}
                            extraContent={
                                <div className="bizum-confirmation-wizard-step__data">
                                    <BlockInfo><p>{successMessageText}</p></BlockInfo>
                                </div>
                            }
                        />
                    </div>
                );
            case 4: // error
                return (
                    <div>
                        <CustomMessageBox
                            icon="icon-warning"
                            title={errorMessageTitle}
                            textLink={goBackButtonLabel}
                            goBackHandler={this.goBackHandler}
                            extraContent={
                                <div className="bizum-confirmation-wizard-step__data">
                                    <BlockInfo><p>{errorMessageText}</p></BlockInfo>
                                </div>
                            }
                        />
                    </div>
                );
        }
    }

    render() {
        return (
            <article className="bizum-confirmation-wizard-view">
                <section className="bizum-confirmation-wizard-view__body">
                    <section className="bizum-confirmation-wizard-step">
                        <div className="bizum-confirmation-wizard-step__content">
                            {this.getMainContent()}
                        </div>
                    </section>
                    {this.buildPreleaveCancelModal()}
                </section>
            </article>
        );
    }
}

BizumConfirmation.propTypes = { // private props
    bizumConfirmation: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    reset: PropTypes.func.isRequired,
    resend: PropTypes.func.isRequired,
    validate: PropTypes.func.isRequired,
    setCode: PropTypes.func.isRequired,
    setScreen: PropTypes.func.isRequired,
    showModal: PropTypes.func.isRequired
};

module.exports.constructor = BizumConfirmation;
module.exports.BizumConfirmation = connect(
    state => ({
        bizumConfirmation: state.bizumConfirmation
    }), {
        reset: bizumConfirmation.reset,
        resend: bizumConfirmation.resend,
        validate: bizumConfirmation.validate,
        setCode: bizumConfirmation.setCode,
        setScreen: bizumConfirmation.setScreen,
        showModal: bizumConfirmation.showModal
    })(withRouter(BizumConfirmation));
